import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import HotThreads from "./components/HotThreads";
import Gossip from "./components/Gossip";
import Zones from "./components/Zones";
import Topics from "./components/Topics";
import Faq from "./components/Faq";
import CtaBanner from "./components/CtaBanner";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Navbar />
      <main>
        <Hero />
        <HotThreads />
        <Gossip />
        <Zones />
        <Topics />
        <Faq />
        <CtaBanner />
      </main>
      <Footer />
    </div>
  );
}